
import { computed, ComputedRef, defineComponent, readonly } from 'vue';
import { usePoint } from '@/compositions/usePoint';
import { AppLabel, AppIcon } from '@comsbi/common/src/types/models';
import { useRoute } from 'vue-router/composables';
import { i18n } from '@/plugins/i18n';

// CS-6437 カスタムアイコン
const ICON = process.env.NODE_ENV === 'local' ? window.ICON || process.env.VUE_APP_ICON : window.ICON;
const customIcon: AppIcon = JSON.parse(ICON || '{}');

const footerContentSettingsJson: string =
  process.env.NODE_ENV === 'local'
    ? window.FOOTER_CONTENT_SETTINGS || process.env.VUE_APP_FOOTER_CONTENT_SETTINGS
    : window.FOOTER_CONTENT_SETTINGS;

const footerContentSettings: {
  customerCardEnabled: boolean;
  couponEnabled: boolean;
  exchangeCouponEnabled: boolean;
  pointHistoryEnabled: boolean;
} = JSON.parse(footerContentSettingsJson);
export default defineComponent({
  name: 'TheTabBar',

  setup(_) {
    const { enabled: pointEnabled } = usePoint();
    const route = useRoute();
    const navItems = computed(() => {
      return [
        {
          to: '/',
          name: i18n.t('menu.customerCard'),
          icon: 'customerCard',
          enabled: footerContentSettings.customerCardEnabled,
        },
        {
          to: '/coupon',
          name: i18n.t('menu.coupon'),
          icon: 'coupon',
          enabled: footerContentSettings.couponEnabled,
        },
        {
          to: '/exchange_coupon',
          name: pointEnabled.value ? i18n.t('menu.exchangeCoupon') : i18n.t('menu.getCoupon'),
          icon: pointEnabled.value ? 'exchangeCoupon' : 'getCoupon',
          enabled: footerContentSettings.exchangeCouponEnabled,
        },
        {
          to: '/point_history',
          name: i18n.t('menu.pointHistory'),
          icon: 'pointHistory',
          enabled: footerContentSettings.pointHistoryEnabled && pointEnabled.value,
        },
      ].filter((v: any) => v.enabled);
    });

    const currentPath = computed(() => route.path);

    const iconName = (name: string) => {
      if (name === 'customerCard') return 'IconBarcode';
      if (name === 'coupon') return 'IconCoupon';
      if (name === 'exchangeCoupon') return 'IconPoint';
      if (name === 'getCoupon') return 'IconPoint'; // CS-6437 デフォルトは既存のままpt icon
      if (name === 'pointHistory') return 'IconHistory';
    };

    return {
      pointEnabled,
      navItems,
      currentPath,
      cdn: process.env.VUE_APP_CDN,
      iconName,
      customMenuIcon: customIcon.menu || {},
    };
  },
});
